<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.5 16.5C3 17.76 2.5 21.5 2.5 21.5C2.5 21.5 6.24 21 7.5 19.5C8.21 18.66 8.2 17.37 7.41 16.59C7.02 16.22 6.51 16.01 5.97 15.99C5.44 15.97 4.91 16.16 4.5 16.5Z"
      :stroke="stroke || 'currentColor'"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 15L9 12C9.53 10.62 10.2 9.3 11 8.05C12.17 6.18 13.8 4.64 15.73 3.58C17.66 2.52 19.83 1.98 22 2C22 4.72 21.22 9.5 16 13C14.74 13.8 13.4 14.47 12 15Z"
      :stroke="stroke || 'currentColor'"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 12H4C4 12 4.55 8.97 6 8C7.62 6.92 11 8 11 8"
      :stroke="stroke || 'currentColor'"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13"
      :stroke="stroke || 'currentColor'"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'RocketIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped></style>
